<template>
  <v-flex xs12 row>
    <v-layout py-3>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            
            <autocomplete
              v-model="filter.period"
              label="Time Period"
              search-key="type"
              :items="$options.periods"
            />
            
            <date-picker 
              v-if="filter.period === 'monthly'" 
              v-model="filter.year_month" 
              :min="minDateFrom" 
              :max="maxDate" 
              label="Year & Month" 
              class="mr-3" 
              type="month" 
            />

            <date-picker 
              v-else 
              v-model="filter.date_from" 
              :min="minDateFrom" 
              :max="maxDate" 
              :label="dateFromLabel" 
              class="mr-3" 
            />

            <date-picker 
              v-if="hasDateTo" 
              v-model="filter.date_to" 
              :disabled="!isDateToEditable"
              :min="minDateTo" 
              :max="maxDateTo" 
              label="Date To" 
              class="mr-3"
            />
            
            <autocomplete 
              v-model="filter.purchase_type"
              label="Type"
              :items="$options.types"
            />

            <search-btn @click="loadReport" />

            <v-spacer></v-spacer>

          </v-card-title>

          <data-table
            :headers="headers"
            :items="processedItems"
            :loading="processing"
            :title="resultTitle"
            :totals="totals"
            :sheet-name="sheetName"
            hide-actions
            download
          ></data-table>

      </v-card>
      </v-flex>
    </v-layout>
    
  </v-flex>
</template>

<script>

  import sumBy from 'lodash/sumBy'

  import { reports } from '../../config/apis'
  import purchaseTypes from '../../config/purchaseTypes'

  import reportMixin from '../../mixins/reports'

  import DataTable from '../../components/DataTable'
  import DatePickerDialog from '../../components/DatePickerDialog'

  export default {
    
    components: {
      'data-table': DataTable,
      'date-picker': DatePickerDialog,
    },

    mixins: [ 
      reportMixin,
    ],

    data () {
      return {
        title: "Purchase Report",
        reportsApiPath: reports.purchase,
        filter: {
          period: "daily",
          date_from: this.today('YYYY-MM-DD'),
          date_to: '',
          year_month: '',
          purchase_type: '',
        },
        hasDateWiseReport: true,
      }
    },

    computed: {
    	
      processedItems() {

        if (this.filter.period === 'monthly') {
          return this.items
        }
          
        return this.items.map(item => {
          return {
            code: item.code,
            purchase_type: item.purchase_type,
            vendor: item.vendor,
            biller_name: item.biller_name,
            subtotal: item.subtotal,
            discount: item.discount,
            round_off: item.round_off,
            tax: item.tax,
            grandtotal: item.grandtotal
          }
        })
        
      },

      totals () {
        if (this.filter.period !== 'monthly' || !this.items.length) return {}

        return {
          purchase_type: "Total",
          purchase_count: sumBy(this.items, 'purchase_count'),
          day_subtotal: sumBy(this.items, 'day_subtotal'),
          day_discount: sumBy(this.items, 'day_discount'),
          day_round_off: sumBy(this.items, 'day_round_off'),
          day_tax: sumBy(this.items, 'day_tax'),
          day_grandtotal: sumBy(this.items, 'day_grandtotal')
        }

      },

    },

    created () {

      let types = [{
            id: "",
            title: "All"
          }]

      for (const [key, val] of Object.entries(this.config.purchaseTypes)) {
        types.push({id: val, title: key})
      }

      this.$options.types = types

      this.$options.itemWiseHeaders = [
        { text: 'Purchase ID', value: 'code', sortable: false},
        { text: 'Purchase Date', value: 'purchase_date', sortable: false},
        { text: 'Vendor', value: 'vendor', sortable: false},
        { text: 'Purchase Added', value: 'biller_name', sortable: false},
        { text: `Subtotal (${this.currency})`, value: 'subtotal', sortable: false, customFilter: 'roundValue', align: 'right'},
        { text: `Discount (${this.currency})`, value: 'discount', sortable: false, customFilter: 'roundValue', align: 'right'},
        { text: `Roundoff (${this.currency})`, value: 'round_off', sortable: false, customFilter: 'roundValue', align: 'right'},
        { text: `GST (${this.currency})`, value: 'tax', sortable: false, customFilter: 'roundValue', align: 'right'},
        { text: `Grand Total (${this.currency})`, value: 'grandtotal', sortable: false, customFilter: 'roundValue', align: 'right'},
      ]

      this.$options.dateWiseHeaders = [
        { text: 'Purchase Date', value: 'purchase_date', sortable: false},
        { text: 'Purchases', value: 'purchase_count', sortable: false, align: 'right'},
        { text: `Subtotal (${this.currency})`, value: 'day_subtotal', sortable: false, customFilter: 'roundValue', align: 'right'},
        { text: `Discount (${this.currency})`, value: 'day_discount', sortable: false, customFilter: 'roundValue', align: 'right'},
        { text: `Roundoff (${this.currency})`, value: 'day_round_off', sortable: false, customFilter: 'roundValue', align: 'right'},
        { text: `GST (${this.currency})`, value: 'day_tax', sortable: false, customFilter: 'roundValue', align: 'right'},
        { text: `Grand Total (${this.currency})`, value: 'day_grandtotal', sortable: false, customFilter: 'roundValue', align: 'right'},
      ]

    },

  }
</script>
